module.exports = __webpack_public_path__ + "static/img/qr_code.378d92b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr_code.png
// module id = XKKh
// module chunks = 184